export default __webpack_public_path__ + "static/media/awlslogo.38539acb.jpg";